import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { deleteGuarantee } from "../thunks/deleteGuarantees";
import { setFetchState } from "../guaranteesDataSlice";

export const useGuaranteeDelete = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (store) => store.data.clearing.guarantees.cancelFetchState
  );

  const dispatch = useDispatch();
  const dispatchDeleteGuarantee = React.useCallback(
    (id: string) => dispatch(deleteGuarantee(id)),
    [dispatch]
  );

  React.useEffect(() => {
    dispatch(setFetchState({ type: "not-started" }));
  }, [dispatch]);

  return [fetchState, dispatchDeleteGuarantee] as [
    typeof fetchState,
    typeof dispatchDeleteGuarantee
  ];
};
